
import { LogHelper } from "@/common/LogHelper";
import Vue from "vue";
import { Component } from "vue-property-decorator";
@Component({
  name: "ProgressBar",
  components: {},
  props: {
    progressBarShowFlag: {
      type: Boolean,
      default: false
    },
    printCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    },
    dialogTitle: {
      type: String,
      default: ""
    }
  },
  watch: {
    progressBarShowFlag(newone, oldone) {
      if (newone) {
        this.progressBarDialogFormVisible = true;
      } else {
        this.progressBarDialogFormVisible = false;
      }
    },
    dialogTitle(newone, oldone) {
      this.eldialogTitle = newone;
    },
    printCount(newone, oldone) {
      if (newone >= 0 && this.totalCount > 0) {
        this.percentage = Math.round((this.printCount / this.totalCount) * 100);
      }
      this.fnshQty = newone;
    },
    totalCount(newone, oldone) {
      LogHelper.WriteLog("T" + newone);
      if (this.printCount >= 0 && newone > 0) {
        this.percentage = Math.round((this.printCount / this.totalCount) * 100);
      }
    }
  }
})
export default class extends Vue {
  public eldialogTitle = "";
  public fnshQty = 0;
  public percentage = 0;
  public format() {
    return () => {
      return Math.round(this.fnshQty);
    };
  }

  public FormOK(result) {
    if (result) {
      this.progressBarDialogFormVisible = true;
    } else {
      this.progressBarDialogFormVisible = false;
    }

    this.$emit("progressBarFormClose");
  }
  public progressBarDialogFormVisible = false;
}
